import { Monitor, Tablet, Smartphone, Wand2, Check, ChevronDown } from "lucide-react";
import { useViewMode } from "@/contexts/ViewModeContext";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

const OPTIONS = [
  { value: "auto",    label: "Automático",         hint: "Detecta o tamanho da tela",       icon: Wand2 },
  { value: "desktop", label: "Computador",         hint: "Visão executiva completa",        icon: Monitor },
  { value: "tablet",  label: "Tablet",             hint: "Cards compactos em duas colunas", icon: Tablet },
  { value: "mobile",  label: "Celular",            hint: "Layout em coluna única e toque",  icon: Smartphone },
];

const ICON_BY_MODE = {
  auto: Wand2,
  desktop: Monitor,
  tablet: Tablet,
  mobile: Smartphone,
};

export default function ViewModeSelector({ compact = false }) {
  const { mode, effective, setMode } = useViewMode();
  const ActiveIcon = ICON_BY_MODE[mode] || Monitor;
  const activeLabel = OPTIONS.find((o) => o.value === mode)?.label || "Modo";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="view-mode-trigger"
          title={`Modo de Visualização: ${activeLabel} (atual: ${effective})`}
          className="flex items-center gap-2 rounded-md border border-border bg-white px-2.5 py-2 text-[13px] font-medium text-foreground hover:bg-secondary transition-colors duration-200"
        >
          <ActiveIcon className="h-4 w-4 text-[#234935]" />
          {!compact && <span className="hidden lg:inline text-[12.5px]">{activeLabel}</span>}
          <ChevronDown className="h-3.5 w-3.5 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[280px]">
        <DropdownMenuLabel className="flex items-center justify-between">
          <span>Modo de Visualização</span>
          <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
            {effective}
          </span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {OPTIONS.map((opt) => {
          const Icon = opt.icon;
          const active = mode === opt.value;
          return (
            <DropdownMenuItem
              key={opt.value}
              data-testid={`view-mode-option-${opt.value}`}
              onSelect={() => setMode(opt.value)}
              className={active ? "bg-secondary" : ""}
            >
              <div className="flex items-start gap-3 w-full">
                <Icon className="h-4 w-4 mt-0.5 text-[#234935]" />
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-[13px] flex items-center gap-2">
                    {opt.label}
                    {active && <Check className="h-3.5 w-3.5 text-[#234935]" />}
                  </div>
                  <div className="text-[11.5px] text-muted-foreground">{opt.hint}</div>
                </div>
              </div>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
